import * as PropTypes from "prop-types"
import styled from "styled-components"
import Typography from "components/styled/Typography"

const TextWrapper = styled.div`
  overflow: hidden;
  margin-bottom: 10px;
`

const Title = styled(Typography)`
  margin: 9px 0;
`

const Subtitle = styled(Typography)`
  margin: 16px 0;
`

export default function Intro({ section }) {
  const { title, subtitle } = section
  const hasTitle = typeof title === "string" && title.trim().length > 0

  return (
    <TextWrapper>
      {hasTitle && (
        <Title variant="title2" weight="medium" center>
          {title}
        </Title>
      )}
      <Subtitle center>{subtitle}</Subtitle>
    </TextWrapper>
  )
}

Intro.propTypes = {
  section: PropTypes.object.isRequired
}
